import type {
  FetchRefundCodeListParams,
  RefundCode
} from 'Services/ControlDataManagement/Features/RefundCode/types'
import type { ListResponse } from 'Services/ControlDataManagement/types'
import { createBaseApi } from 'Util/ApiClient'

export const refundCodeApi = createBaseApi({
  reducerPath: 'refundCodeApi',
  keepUnusedDataFor: 10,
  tagTypes: ['RefundCode']
}).injectEndpoints({
  endpoints: builder => ({
    getRefundCodes: builder.query<ListResponse<RefundCode>, FetchRefundCodeListParams | undefined>({
      query: params => ({
        url: '/api/v1/refund-code/',
        params
      }),
      providesTags: result =>
        result
          ? [
              ...result.resources.map(({ id }) => ({ type: 'RefundCode', id }) as const),
              { type: 'RefundCode', id: 'LIST' }
            ]
          : [{ type: 'RefundCode', id: 'LIST' }]
    }),
    getSingleRefundCode: builder.query<RefundCode, string>({
      query: id => `/api/v1/refund-code/${id}/`,
      providesTags: (_result, _error, id) => [{ type: 'RefundCode', id }]
    }),
    createSingleRefundCode: builder.mutation<RefundCode, Partial<RefundCode>>({
      query: data => ({
        url: `/api/v1/refund-code/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: [{ type: 'RefundCode', id: 'LIST' }]
    }),
    updateSingleRefundCode: builder.mutation<
      RefundCode,
      { refund_code_id: string } & Partial<RefundCode>
    >({
      query: data => ({
        url: `/api/v1/refund-code/${data.refund_code_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: 'RefundCode', id }]
    }),
    deleteSingleRefundCode: builder.mutation<Record<string, never>, string>({
      query: id => ({
        url: `/api/v1/refund-code/${id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: [{ type: 'RefundCode', id: 'LIST' }]
    })
  })
})

export const {
  useGetRefundCodesQuery,
  useGetSingleRefundCodeQuery,
  useCreateSingleRefundCodeMutation,
  useUpdateSingleRefundCodeMutation,
  useDeleteSingleRefundCodeMutation
} = refundCodeApi
